// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdraw_title_wrap {
  margin-top: 30px;
  display: flex;
  align-items: center;
  border: 1px solid #FBCBA7;
  border-radius: 8px;
  padding: 15px;
}
.withdraw_title_wrap h3 {
  margin: 0px;
  margin-bottom: 5px;
  color: var(--light-color);
  font-weight: 500;
  font-size: 16px;
}
.withdraw_title_wrap p {
  margin: 0px;
  color: var(--text-color);
  font-weight: 400;
  font-size: 12px;
}
.withdraw_title_wrap .withdraw_title_icn {
  margin-right: 30px;
}
.withdraw_title_wrap .withdraw_title_icn svg {
  color: #FBCBA7;
  font-size: 25px;
}

.withdraw_bal_sum {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--secondary-color);
  padding: 10px;
  border-radius: 8px;
  margin-top: 20px;
}
.withdraw_bal_sum .input_icn {
  color: #444971;
  font-weight: 500;
  font-size: 28px;
}
.withdraw_bal_sum p {
  margin-bottom: 0px;
  color: var(--text-color);
}
.withdraw_bal_sum .input_title {
  color: var(--dark-color);
  background: var(--primary-color);
  border-radius: 20px;
  font-weight: 500;
  padding: 2px 6px 0px;
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/withdraw.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AACR;AAEI;EACI,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAGQ;EACI,cAAA;EACA,eAAA;AADZ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAKI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAMI;EACI,kBAAA;EACA,wBAAA;AAJR;AAOI;EACI,wBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AALR","sourcesContent":[".withdraw_title_wrap {\r\n    margin-top: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    border: 1px solid #FBCBA7;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n\r\n    h3 {\r\n        margin: 0px;\r\n        margin-bottom: 5px;\r\n        color: var(--light-color);\r\n        font-weight: 500;\r\n        font-size: 16px;\r\n    }\r\n\r\n    p {\r\n        margin: 0px;\r\n        color: var(--text-color);\r\n        font-weight: 400;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .withdraw_title_icn {\r\n        margin-right: 30px;\r\n\r\n        svg {\r\n            color: #FBCBA7;\r\n            font-size: 25px;\r\n        }\r\n    }\r\n}\r\n\r\n.withdraw_bal_sum {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    background-color: var(--secondary-color);\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    margin-top: 20px;\r\n\r\n    .input_icn {\r\n        color: #444971;\r\n        font-weight: 500;\r\n        font-size: 28px;\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 0px;\r\n        color: var(--text-color);\r\n    }\r\n\r\n    .input_title {\r\n        color: var(--dark-color);\r\n        background: var(--primary-color);\r\n        border-radius: 20px;\r\n        font-weight: 500;\r\n        padding: 2px 6px 0px;\r\n        font-size: 11px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
